export default {"src":"/_next/static/media/fjc.b591722f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};